export default {
    getHeaderFields: state => state.headerFields,
    getFormActions: state => state.formActions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,

    getBedHeaderFields: state => state.bedHeaderFields,
    getBedFormActions: state => state.bedFormActions,
    getBedActions: state => state.bedActions,
    getBedRowActions: state => state.bedRowActions,
    isBedFormOpen: state => state.bedFormIsOpen,
    isBedGridOpen: state => state.bedGridIsOpen,

}
